/* Buy-box column + gallery slider mechanics.

   WHAT .main ACTUALLY IS: not a single image swapped in place, but a horizontal FLEX
   SLIDER holding all six photos side by side, scrolled between.

   THE BUG THAT HID HALF THE PHOTOS (found 10 Aug, measured live):
   the theme sets `.lp .main{justify-content:center}`. On a flex row whose content
   overflows, centring splits the overflow across BOTH sides — the track was shifted
   1885px to the LEFT of the scroll origin, so the slides sat at offsets
     -1745, -991, -237, 517, 1271, 2025
   scrollLeft cannot go below 0, so the first two-and-a-half photos were unreachable by
   scroll, drag or click. scrollWidth read 2639 instead of 6 x 754 = 4524, which is the
   fingerprint of this bug. It looked exactly like the images had been deleted; they had
   not — the product still had all six media, READY, on the server.
   justify-content:flex-start puts the whole track back inside reachable scroll space.

   Two earlier fixes also assumed a single image and broke it:
     - `width:100%` with the theme's default `flex: 0 1 auto` let the slides SHRINK, so
       the track fell out of alignment and two photos showed at once
     - swapping the first <img>'s src changed the wrong slide

   Slides take `flex: 0 0 100%` so they are exactly one viewport wide and cannot shrink,
   with scroll-snap so the track can never rest between two photos.
   luma-thumbs.js scrolls it; luma-gallery.js sets the height.

   Column balance follows the reference site: media takes the majority of the width, buy
   box is a fixed narrower column. The text drives the image height — widen this column
   and the hero gets smaller. */
(function(){
var s=document.createElement('style');
s.textContent=
'@media(min-width:901px){'+
'  .lp .wrap{grid-template-columns:1fr 470px!important;gap:48px!important;}'+
'  .lp .details{padding-left:8px!important;}'+
'  .lp .diff .ac{padding-top:15px!important;padding-bottom:15px!important;}'+
'  .lp .diff .ac .bd{line-height:1.55!important;}'+
'  .lp .details .hook{margin-bottom:16px!important;}'+
'  .lp .details .ship{margin-top:10px!important;margin-bottom:10px!important;}'+
'}'+
/* --- slider track ---
   justify-content MUST be flex-start: see the header comment. Centring makes the
   left half of the track unreachable. align-items:stretch keeps each slide full height. */
'.lp .wrap .main{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;'+
'  justify-content:flex-start!important;align-items:stretch!important;'+
'  padding-left:0!important;padding-right:0!important;'+
'  overflow-x:auto!important;overflow-y:hidden!important;'+
'  scroll-snap-type:x mandatory!important;scroll-behavior:smooth!important;'+
'  -ms-overflow-style:none!important;scrollbar-width:none!important;}'+
'.lp .wrap .main::-webkit-scrollbar{display:none!important;height:0!important;}'+
/* --- each slide is exactly one frame wide and must not shrink --- */
'.lp .wrap .main img,.lp .wrap .main .mimg{flex:0 0 100%!important;width:100%!important;'+
'  height:100%!important;max-width:none!important;max-height:none!important;min-width:0!important;'+
'  min-height:0!important;object-fit:cover!important;display:block!important;'+
'  margin:0!important;scroll-snap-align:start!important;scroll-snap-stop:always!important;}';
document.head.appendChild(s);
})();